export const FETCH_DEFAULT_QUOTES_SUCCESS = 'FETCH_DEFAULT_QUOTES_SUCCESS';
export const FETCH_DEFAULT_QUOTES_FAILURE = 'FETCH_DEFAULT_QUOTES_FAILURE';

export const ADD_COLOR_TO_PRODUCT_SUCCESS = 'ADD_COLOR_TO_PRODUCT_SUCCESS';
export const ADD_COLOR_TO_PRODUCT_FAILURE = 'ADD_COLOR_TO_PRODUCT_FAILURE';

export const ADD_SIZE_TO_PRODUCT_SUCCESS = 'ADD_SIZE_TO_PRODUCT_SUCCESS';
export const ADD_SIZE_TO_PRODUCT_FAILURE = 'ADD_SIZE_TO_PRODUCT_FAILURE';

export const FETCH_PI_DETAILS_SUCCESS = 'FETCH_PI_DETAILS_SUCCESS';
export const FETCH_PI_DETAILS_FAILURE = 'FETCH_PI_DETAILS_FAILURE';

export const FETCH_BRAND_LOCATION_LIST_SUCCESS = 'FETCH_BRAND_LOCATION_LIST_SUCCESS';
export const FETCH_BRAND_LOCATION_LIST_FAILURE = 'FETCH_BRAND_LOCATION_LIST_FAILURE';

export const FETCH_BENEFICIARY_LIST_SUCCESS = 'FETCH_BENEFICIARY_LIST_SUCCESS';
export const FETCH_BENEFICIARY_LIST_FAILURE = 'FETCH_BENEFICIARY_LIST_FAILURE';

export const FETCH_BENEFICIARY_ALL_SUCCESS = 'FETCH_BENEFICIARY_ALL_SUCCESS';
export const FETCH_BENEFICIARY_ALL_FAILURE = 'FETCH_BENEFICIARY_ALL_FAILURE';

export const FETCH_NITEX_BANK_DETAILS_SUCCESS = 'FETCH_NITEX_BANK_DETAILS_SUCCESS';
export const FETCH_NITEX_BANK_DETAILS_FAILURE = 'FETCH_NITEX_BANK_DETAILS_FAILURE';

export const FETCH_ORDER_PLACE_WORKFLOW_SUCCESS = 'FETCH_ORDER_PLACE_WORKFLOW_SUCCESS';
export const FETCH_ORDER_PLACE_WORKFLOW_FAILURE = 'FETCH_ORDER_PLACE_WORKFLOW_FAILURE';

export const FETCH_ORDER_DETAILS_INFO_SUCCESS = 'FETCH_ORDER_DETAILS_INFO_SUCCESS';
export const FETCH_ORDER_DETAILS_INFO_FAILURE = 'FETCH_ORDER_DETAILS_INFO_FAILURE';

export const FETCH_ALL_USERS_BY_TYPES_SUCCESS = 'FETCH_ALL_USERS_BY_TYPES_SUCCESS';
export const FETCH_ALL_USERS_BY_TYPES_FAILURE = 'FETCH_ALL_USERS_BY_TYPES_FAILURE';
export const SET_PROJECT_LIST = 'SET_PROJECT_LIST';
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const SET_LOADING = 'SET_LOADING';
export const TOGGLE_FILTER = 'TOGGLE_FILTER';
